import { createReducer } from "@reduxjs/toolkit";
import { SEO_ERROR, SEO_LOADING, SEO_LIST } from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const seoReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(SEO_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(SEO_ERROR, (state, { payload }) => {
      state.error = payload;
    })
    .addCase(SEO_LIST, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    });
});

export default seoReducer;
